// extracted by mini-css-extract-plugin
export default {"footerBg":"i-z","footerTopLinks":"j-z","footerFeedback":"k-z","footerSocial":"l-z","footerLegalLinks":"m-z","footerIconCards":"n-z","footerBotCopy":"o-z"};